import React, { useCallback, useEffect, useState } from 'react';
import utils from '@common/utils';
import { fetchUtil } from '../../common/util';
import URL from '../../common/URL';

import './index.less';

const BLOG_COUNT = 2;

export default ({ title, currencyInfo }) => {
  const [blogTags, setBlogTags] = useState([]);
  const [blogs, setBlogs] = useState([]);

  const getBlogTags = async () => {
    try {
      const data = await fetchUtil(URL.GET_BLOG_TAGS);
      setBlogTags(data);
    } catch {
      setBlogTags([]);
    }
  };

  const getMarketReportBlog = async (count = 10) => {
    let data;
    try {
      data = await fetchUtil(
        `${URL.GET_MARKET_REPORT_BLOG}?per_page=${count}&_embed`
      );
    } catch {
      data = [];
    }
    return data.slice(0, count);
  };

  const renderTitle = (rendered) => {
    if (rendered.indexOf(']') > 0) {
      return rendered.split(']')[1];
    }

    return rendered;
  };

  const getBlogByTags = useCallback(async () => {
    const { symbol } = currencyInfo;
    const blog = blogTags.find((b) => b.name === symbol?.toUpperCase());
    if (!blog) {
      const result = await getMarketReportBlog(2);
      setBlogs(result);
      return;
    }

    const { id, count } = blog;
    try {
      const data = await fetchUtil(`${URL.GET_BLOG_BY_TAGS}${id}&_embed`);
      const result = data?.slice(0, 2) || [];
      if (count < BLOG_COUNT) {
        const marketBlogs = await getMarketReportBlog();
        const blogKeys = result.map((b) => b.id);
        while (marketBlogs?.length && result.length < BLOG_COUNT) {
          const b = marketBlogs.shift();
          if (!blogKeys.includes(b.id)) {
            result.push(b);
          }
        }
      }
      setBlogs(result);
    } catch {
      setBlogTags([]);
    }
  }, [blogTags]);

  useEffect(() => {
    if (blogTags.length) {
      getBlogByTags();
    }
  }, [getBlogByTags, blogTags]);

  useEffect(() => {
    getBlogTags();
  }, []);

  const { videos } = currencyInfo;

  return (
    <div className="news-content">
      <div className="news-title">{title}</div>
      <div className="news-box">
        {blogs.map((b) => {
          const {
            title: { rendered },
            link,
          } = b;
          return (
            <a href={link} target="_blank" rel="noreferrer" key={link}>
              <div className="news-item">
                <div className="news-item-title-box">
                  <div className="news-item-title">
                    <p>{renderTitle(rendered)}</p>
                    <div className="news-item-info">
                      <span>OKJ Blog</span>
                    </div>
                  </div>
                  <img src={utils.getBlogImg(b)} alt="news icon" />
                </div>
              </div>
            </a>
          );
        })}
        {videos?.map((video) => {
          const { title: youtubeTitle, vid } = video;
          return (
            <div className="youtube-box">
              <div className="youtube-img-box">
                <iframe
                  width="100%"
                  height="200"
                  src={`https://www.youtube.com/embed/${vid}`}
                  title={youtubeTitle}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                />
              </div>
              <div className="youtube-title">{youtubeTitle}</div>
              <div className="youtube-create-time">OKJ YouTube</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
